import { SEARCH_MEMBER_TYPE, SEARCH_TYPE } from '../interface';
import { getQueryString } from '@umu/umu-dom';
import { SWITCH_STATUS } from '../interface';
const COLOR_MAP = [
    '#ffbd2a',
    '#e53685',
    '#ff6666',
    '#29bebf',
    '#e55b36',
    '#0fabdf',
    '#bc4ca8',
    '#9453b6',
    '#05a78a',
];
const overlayInnerStyle = {
    lineHeight: '0.2rem',
    color: '#222222',
    fontSize: '0.14rem',
};
const getUrlParams = (defaultData?: Record<string, string>) => {
    let memberType = Number(getQueryString('type'));
    let searchId: string = getQueryString('id') || defaultData?.searchId || '';
    if (![SEARCH_MEMBER_TYPE.DEPARTMENT, SEARCH_MEMBER_TYPE.PERSONAL].includes(memberType)) {
        memberType = SEARCH_MEMBER_TYPE.DEPARTMENT;
        searchId = '0';
    }
    return Object.assign({}, defaultData || {}, {
        memberType,
        searchType: Number(getQueryString('searchType')) || SEARCH_TYPE.KNOWLEDGE_POINT_DEPARTMENT,
        searchId,
        fromTo: getQueryString('fromTo'),
        fromUrl: getQueryString('fromUrl'),
        isMultiple: Number(getQueryString('isMultiple')) === SWITCH_STATUS.YES,
    });
};
export { getUrlParams, COLOR_MAP, overlayInnerStyle };
